import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    operaMyList:[]
};
const mutations= {
  operaMyList(state, data){
        state.operaMyList = data;
    }
};


export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/operaMyList.js